import React, { useContext } from 'react';
import { defaultCoreConfig } from './CoreConfig';
import { jsx as _jsx } from "react/jsx-runtime";
export const CoreConfigContext = /*#__PURE__*/React.createContext(defaultCoreConfig);
export const CoreConfigProvider = ({
  children,
  config
}) => /*#__PURE__*/_jsx(CoreConfigContext.Provider, {
  value: config,
  children: children
});
export const useCoreConfig = () => {
  const context = useContext(CoreConfigContext);
  if (context === undefined) {
    throw new Error('useCoreConfig must be used within a CoreConfigProvider');
  }
  return context;
};